import { render } from "./NumberFormatted.vue?vue&type=template&id=5a3c76c3"
import script from "./NumberFormatted.vue?vue&type=script&lang=js"
export * from "./NumberFormatted.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__